import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { BACKEND_URL, AUTH_TOKEN_KEY } from "./constants";

const TIMEOUT = 30 * 1000;

axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = BACKEND_URL;

const setupAxiosInterceptors = (onUnauthenticated: () => void) => {
	const onRequestSuccess = (config: AxiosRequestConfig) => {
		const token =
			localStorage.getItem(AUTH_TOKEN_KEY) ||
			sessionStorage.getItem(AUTH_TOKEN_KEY);
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	};
	const onResponseSuccess = (response: AxiosResponse) => response;
	const onResponseError = (error: any) => {
		const status = error.status || (error.response ? error.response.status : 0);
		if (status === 403 || status === 401) {
			onUnauthenticated();
		}
		return Promise.reject(error.response);
	};
	axios.interceptors.request.use(onRequestSuccess);
	axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;